import script from "./SelectorObj.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectorObj.vue?vue&type=script&setup=true&lang=js"

import "./SelectorObj.vue?vue&type=style&index=0&id=151944f4&scoped=true&lang=postcss"

import exportComponent from "/var/www/app.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151944f4"]])

export default __exports__